import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Iframe from 'react-iframe'
import { isIOS, isAndroid, osName } from 'mobile-device-detect';
import PropTypes from "prop-types";
import LoadingButton from '@mui/lab/LoadingButton';

export default function Repostview(props) {
    const { url } = props
    const [loading, setLoading] = React.useState(true);

    const shouldOpenInNewTab = osName === "Mac OS" || isAndroid || isIOS;

    const handleIframeLoad = () => {
        setLoading(false);
    };

    React.useEffect(() => {
        setLoading(true);
    }, [url]);

    React.useEffect(() => {
        if (shouldOpenInNewTab && url) {
            window.open(url, "_blank");
        }
    }, [shouldOpenInNewTab, url]);

    if (!url) {
        return null;
    }

    if (shouldOpenInNewTab) {
        return null;
    }

    return (
        <React.Fragment>
            <CssBaseline />
            {loading && <LoadingButton loading variant="text" />}
            <Box
                sx={{
                    width: "100%",
                    height: "calc(100vh - 120px)",
                    minHeight: 400,
                    position: "relative",
                }}
            >
                <Iframe
                    url={url}
                    position="relative"
                    onLoad={handleIframeLoad}
                    width="100%"
                    height="100%"
                    overflow="hidden"
                    scrolling="yes"
                    styles={{ border: "none" }}
                />
            </Box>
        </React.Fragment>
    );
}

Repostview.propTypes = {
    url: PropTypes.string,
};
